import React, { useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';

import {
  CreateUpdateArticleHarmfulFactorSuppExamDictDto,
  GetArticleHarmfulFactorSuppExamDictDto,
  GetHarmfulFactorDto,
  GetSupportingExaminationDictDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { articleHarmfulFactorSuppExamDictData } from '../../../common/spdCore/contexts/ArticleContext';
import { Option } from '../Selects/Selector';
import HarmfulFactorSelector from '../HarmfulFactor/HarmfulFactorSelector';
import SupportingExaminationDictMultiSelector from '../SupportingExaminationDict/SupportingExaminationDictMultiSelector';

interface Props {
  entries: GetArticleHarmfulFactorSuppExamDictDto[];
  onChange: (dtos: CreateUpdateArticleHarmfulFactorSuppExamDictDto[]) => void;
}

export const ArticleHarmfulFactorSuppExamDictEditor: React.FC<Props> = ({
  entries,
  onChange,
}) => {
  const [items, setItems] = useState<GetArticleHarmfulFactorSuppExamDictDto[]>(
    [],
  );
  const [selectedFactor, setSelectedFactor] = useState<Option | null>(null);
  const [selectedDict, setSelectedDict] = useState<Option | null>(null);

  useEffect(() => {
    setItems(entries);
  }, [entries]);

  const handleAdd = () => {
    if (!selectedFactor || !selectedDict) {
      return;
    }
    const duplicate = items.some(
      e =>
        e.harmfulFactorId === selectedFactor.value &&
        e.supportingExaminationDictId === selectedDict.value,
    );
    if (duplicate) {
      return;
    }

    const newEntry: GetArticleHarmfulFactorSuppExamDictDto = {
      id: '',
      harmfulFactorId: selectedFactor.value,
      harmfulFactor: { name: selectedFactor.label } as GetHarmfulFactorDto,
      supportingExaminationDictId: selectedDict.value,
      supportingExaminationDict: {
        name: selectedDict.label,
      } as GetSupportingExaminationDictDto,
    };
    const next = [...items, newEntry];
    setItems(next);
    onChange(next.map(articleHarmfulFactorSuppExamDictData));
    setSelectedFactor(null);
    setSelectedDict(null);
  };

  const handleDelete = (index: number) => {
    const next = items.filter((_, i) => i !== index);
    setItems(next);
    onChange(next.map(articleHarmfulFactorSuppExamDictData));
  };

  return (
    <>
      <Table size="sm" className="mt-2">
        <thead>
          <tr>
            <th>Czynnik szkodliwy</th>
            <th>Badanie pomocnicze</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {items.map((e, i) => (
            <tr key={i}>
              <td className="align-middle">{e.harmfulFactor?.name}</td>
              <td className="align-middle">
                {e.supportingExaminationDict?.name}
              </td>
              <td className="align-middle">
                <Button
                  size="sm"
                  variant="outline-danger"
                  onClick={() => handleDelete(i)}
                >
                  Usuń
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex gap-2 align-items-center mt-2">
        <div className="flex-grow-1">
          <HarmfulFactorSelector
            value={selectedFactor?.value}
            onChange={(opt: Option) => setSelectedFactor(opt ?? null)}
            clearable
          />
        </div>
        <div className="flex-grow-1">
          <SupportingExaminationDictMultiSelector
            multi={false}
            value={selectedDict?.value}
            onChange={(opt: Option) => setSelectedDict(opt ?? null)}
          />
        </div>
        <Button
          size="sm"
          variant="outline-primary"
          disabled={!selectedFactor || !selectedDict}
          onClick={handleAdd}
        >
          Dodaj
        </Button>
      </div>
    </>
  );
};
